import { Injectable } from '@angular/core';
import { CryptoService } from '../../commonService/crypto.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { BehaviorSubject } from 'rxjs';
import { CookiesService } from '../../cookies.service';
import { Router } from '@angular/router';
import { PreviousPageCaptureService } from '../previous-page-capture.service';

@Injectable({
  providedIn: 'root'
})
export class ApprovalManagementService {
  url: string[] = this._Router.routerState.snapshot.url.split("/").filter(($) => !!$);
  approvalListing = new BehaviorSubject<any>(null)
  $approvalList = this.approvalListing.asObservable();

  sendData(data: any) {
    this.approvalListing.next(data)
  }
  routeUrl = {
    currentRoute: '',
    nextRoute: ''
  }
  formatRouteName(route: string): string {
    return route
      .split('-')                         // ['traveler', 'management']
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');                         // 'Traveler Management'
  }
    currectPageByUrl(url: any) {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const segments = url.replace(/\/+$/, '').split('/');
    let lastSegment = segments.pop() || '';
    if (uuidRegex.test(lastSegment)) {
      lastSegment = segments.pop() || '';
    }
    if (/^\d+$/.test(lastSegment)) {
      lastSegment = segments.pop() || '';
    }
    if (lastSegment.includes('type=1') || lastSegment.includes('type=2')) {
      lastSegment = lastSegment.split('?')[0];
    }
    return lastSegment;
  }

  constructor(private readonly navService:PreviousPageCaptureService, private _Router: Router, private crypto: CryptoService, private _CommonService: CommonService, private readonly cookiesService:CookiesService) { }

  getUserRole(): string {
    const travelArranger = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string;
    switch (travelArranger) {
      case '0': return 'Admin';
      case '1': return 'TravelArranger';
      case '2': return 'Employee';
      default: return ''
    }
  }

  currentPage(): any {
    const url = this.currectPageByUrl(this.navService.getCurrentUrl);
    // Remove query params if they exist
    return url;
  }

  previousPage(): any {
    const url = this.currectPageByUrl(this.navService.getPreviousUrl);
    // Get last route segment
    return url;
  }


  // setGTM(analytics:any,scriptName:string,data:any){
  //   if(this.hasAcceptedCookies()){
  //     logEvent(analytics,scriptName, data);
  //   }
  // }
   setGTM(analytics: any, scriptName: string, data: any) {
    if (this.hasAcceptedCookies()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    }
  }
  hasAcceptedCookies(): boolean {
    let cookie = localStorage.getItem('cookieAccepted') === 'true';
    return cookie;
  }

  page_landing(eventCategory: string, resultCount: any, subAction: string) {
    try {

      const eventData = {
        'event': 'page_landing',
        'previous_screen_name':  this.previousPage(), // dynamically capture the previous page name/title, if no previous page, then NA
        // 'event_action':  'Menu Click', // dynamically capture the previous tab user is on/title, if no previous page, then NA
        'screen_name':  this.currentPage() || 'NA', // dynamically capture the current page name/title
        'no_of_results': resultCount && resultCount > 0 ? resultCount : 'NA', // pass number of results, NA if not applicable
        'member': this.getUserRole(),   // dynamically capture ex: employee
        'action': this._CommonService.actionName,// dynamically capture the feature name
        'subaction': subAction// dynamically  capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'page_landing', eventData);

    } catch (error) {
      //console.error('GTM - Error in page_landing:', error)
    }
  }

  approval_add(CTALink: string, result: number) {
    try {
      const eventData = {
  'event': 'approval_add',
  'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
  'event_action': `${CTALink} Click`, // Dynamically capture the CTA
  'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
  'link_name': CTALink, // static
  'no_of_results': result?result:'NA', // pass number of results, NA if not applicable
  'member': this.getUserRole(), // dynamically capture ex: employee
  'action': this._CommonService.actionName, // dynamically capture the feature name
  'subaction': 'Approval Management WorkFlow' // dynamically capture the POD name
      };
      //console.log("approval_add", eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_add', eventData);

    } catch (error) {
      //console.error("approval_add", error)
    }
  }

  approval_management(CTALink: string, result: number) {
    try {
      const eventData = {
       'event': 'approval_management_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': CTALink, // dynamically capture CTA if applicable eg Remove
        'no_of_results': result, // pass number of results, NA if not applicable
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };
      //console.log("approval_management", eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_management_click', eventData);


    } catch (error) {
      //console.error("approval_management", error)
    }
  }


  approval_remove(CTALink: string) {
    try {
      const eventData = {
       'event': 'approval_remove',
        'screen_name': 'Approval Remove PopUp', // static
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink == 'Proceed' ? 'Confirm' : 'Cancel'} Click`, // Dynamically capture the CTA
        'link_name': CTALink, // dynamically capture CTA if applicable eg Cancel
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };
      //console.log("approval_remove", eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_remove', eventData);


    } catch (error) {
      //console.error("approval_remove", error)
    }
  }


  approval_remove_success(CTALink: string) {
    try {
      const eventData = {
       'event': 'approval_remove_success',
        'screen_name': 'Approval Removal popUp', // static
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': 'Success', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };
      //console.log("approval_remove_success", eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_remove_success', eventData);
    } catch (error) {

    }
  }

  approval_menu_click(LinkName:string) {
    try {
      const eventData = {
        event: 'approval_menu_click',
        screen_name: this.currentPage() || 'NA', // Dynamically capture the page name
        event_action: `Menu Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'approval_menu_click', eventData);
    } catch (error) {}
  }

  approvalWorkflowSetting_menu_click(LinkName:string) {
    try {
      const eventData = {
        event: 'approval_menu_click',
        screen_name: 'approvalflow-form', // Dynamically capture the page name
        event_action: `Menu Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: 'workflow-setting', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'approval_menu_click', eventData);
    } catch (error) {}
  }

  approval_workflow(eventCategory: string, action: string) {
    try {
      const eventData = {
        'event': 'approval_workflow_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${action} Click`, // Dynamically capture the CTA
        'link_name': 'Cancel', // static
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      }
      this.setGTM(this.cookiesService.analytics, 'approval_workflow_click', eventData);
    } catch (error) {
      //console.error('GTM - Error in approval_workflow:', error)
    }
  }

  approval_edit_success(action:string){
    try {
      const eventData = {
        'event': 'approval_edit_success',
        'screen_name': 'Approval Workflow', // Dynamically capture the tab name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${action} Click`, // Dynamically capture the CTA
        'link_name': 'Success', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      }
      this.setGTM(this.cookiesService.analytics, 'approval_edit_success', eventData);
    } catch (error) {
      //console.error('GTM - Error in approval_workflow:', error)
    }
  }

  // workflow_next1(data: any,ctaLink:string) {
  //   try {
  //     const form = data.formData.form;
  //     const list = data.formData.lists
  //     const product = list.products.find((item: { productCode: any; }) => item.productCode == form.productType);
  //     const travelCat = list.travellerCategories.find((item: { travelCategoryId: any; }) => item.travelCategoryId == form.travelCategory);
  //     const appliedON = list.appliedOn.find((item: { id: number }) => item.id == form.workFlowAppliedOn);

  //     //Convert appliedForIDs in Number
  //     const ids = form.appliedForID.split(",").map((id: string) => Number(id.trim()));
  //     const appliedForList = list.appliedFor.filter((item: { id: number }) => ids.includes(item.id));
  //     const associatesName = appliedForList.map((x: any) => x.name).join(',')

  //     const eventData = {
  //      'event': 'approval_workflow_save',
  //       'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
  //       'event_action': `${ctaLink} Click`, // Dynamically capture the CTA
  //       'link_name':  `Product: ${product.productName || ''} | Travel Category: ${travelCat.travelCategory || ''} | Workflow applied on: ${appliedON.name || ''} | Associate with: ${associatesName || ''}`, // dynamically capture the filled details
  //       'member':  this.getUserRole(), // dynamically capture ex: employee
  //       'action': this._CommonService.actionName, // dynamically capture the feature name
  //       'subaction': 'Approval Management Workflow' // dynamically capture the POD name
  //     }

  //     this.setGTM(this.cookiesService.analytics, 'approval_workflow_save', eventData);
  //   } catch (error) {
  //     //console.error('GTM - Error in approval_workflow:', error)

  //   }
  // }

  workflow_next(data: any, ctaLink: string) {
  try {
    const form = data?.formData?.form || {};
    const list = data?.formData?.lists || {};

    const product = list?.products?.find(
      (item: any) => item.productCode == form?.productType
    );

    const travelCat = list?.travellerCategories?.find(
      (item: any) => item.travelCategoryId == form?.travelCategory
    );

    const appliedON = list?.appliedOn?.find(
      (item: any) => item.id == form?.workFlowAppliedOn
    );

    const ids = form?.appliedForID
      ? form.appliedForID.split(',').map((id: string) => Number(id.trim()))
      : [];

    const appliedForList = list?.appliedFor?.filter(
      (item: any) => ids.includes(item.id)
    ) || [];

    const associatesName = appliedForList.map((x: any) => x.name).join(',');

    const eventData = {
      event: 'approval_workflow_save',
      screen_name: this.currentPage() || 'NA',
      event_action: `${ctaLink} Click`,
      link_name: `Product: ${product?.productName || ''} | Travel Category: ${travelCat?.travelCategory || ''} | Workflow applied on: ${appliedON?.name || ''} | Associate with: ${associatesName}`,
      member: this.getUserRole(),
      action: this._CommonService.actionName,
      subaction: 'Approval Management Workflow'
    };
    this.setGTM(this.cookiesService.analytics, 'approval_workflow_save', eventData);

  } catch (error) {
    console.error(' GTM ERROR:', error);
  }
}

  approval_flow_cancel(ctaLink: string) {
    try {

      const eventData = {
        'event': 'approval_flow_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the page name
        'event_action': `${ctaLink} Click`, // Dynamically capture the CTA
        'link_name': 'Cancel', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'approval_flow_click', eventData);

    } catch (error) {
      //console.error('GTM - Error in approval_flow:', error)

    }
  }

  approval_view(ctaLink: string) {
    try {

      const eventData = {
        'event': 'approval_view',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the page name
        'event_action': `${ctaLink} Click`, // Dynamically capture the CTA
        'link_name': 'View', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'approval_view', eventData);

    } catch (error) {
      //console.error('GTM - Error in approval_flow:', error)

    }
  }


  getApproverName(id: number, travelerList: any[]) {
    const user = travelerList.find(t => t.saUserId === id);

    if (!user || !user.userName) return 'NA';

    // Remove titles (case-insensitive)
    return user.userName.replace(/^(mr|mrs|ms|miss|dr|prof|sir|madam)\s+/i, '').trim();
  }

  approval_save(ctaLink: string, formdata: any, travelerList: any[]) {
    try {

      const inPolicyNames = {
        level1: this.getApproverName(formdata.inPolicyApproverIDL1, travelerList),
        level2: this.getApproverName(formdata.inPolicyApproverIDL2, travelerList),
        level3: this.getApproverName(formdata.inPolicyApproverIDL3, travelerList)
      };

      const outPolicyNames = {
        level1: this.getApproverName(formdata.outPolicyApproverIDL1, travelerList),
        level2: this.getApproverName(formdata.outPolicyApproverIDL2, travelerList),
        level3: this.getApproverName(formdata.outPolicyApproverIDL3, travelerList)
      };

      const eventData = {
       'event': 'approval_flow_save',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'event_action': `${ctaLink} Click`, // Dynamically capture the CTA
        'link_name':`Approval Management Workflow: ${formdata.approvalFlow === 'SEQ' ? 'Sequential' : 'Parallel'} | Total Approvers: ${formdata.totalApprovals || ''} | In Policy Approvers: Level 1 - ${inPolicyNames.level1}, Level 2 - ${inPolicyNames.level2}, Level 3 - ${inPolicyNames.level3} | Out of Policy Approvers: Level 1 - ${outPolicyNames.level1}, Level 2 - ${outPolicyNames.level2}, Level 3 - ${outPolicyNames.level3}`, // dynamically capture filled details
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };

      //console.log('approval_save', eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_flow_save', eventData);
    } catch (error) {
      //console.error('GTM - Error in approval_save:', error)

    }
  }

  approval_management_filter(ctaLink: string) {
    try {
      const eventData = {
       'event': 'approval_management_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'event_action': `${ctaLink} Click`, // Dynamically capture the CTA
        'link_name': 'filter', // static
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };

      //console.log('approval_management_filter', eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_management_click', eventData);
    } catch (error) {
      //console.error('GTM - Error in approval_management_filter:', error)

    }
  }

  approval_management_sort(ctaLink: string) {
    try {
      const eventData = {
        'event': 'approval_management_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'event_action': `${ctaLink} Click`, // Dynamically capture the CTA
        'link_name': 'sort', // static
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };

      //console.log('approval_management_sort', eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_management_click', eventData);
    } catch (error) {
      //console.error('GTM - Error in approval_management_sort:', error)

    }
  }

  approval_management_filterApply(selectedID: any, filterList: any) {
    

    const result = filterList.filter((item: { id: any; }) => selectedID.includes(item.id))
    const actionname = result.map((item: { name: any; }) => item.name).join('|')
    // const result = list.filter(item => selectedIds.includes(item.id));

    try {
      const eventData = {
        'event': 'approval_management_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'event_action': actionname, // Dynamically capture the filter applied
        'link_name': 'Apply', //static
      
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };

      //console.log('approval_management_filterApply', eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_management_click', eventData);
    } catch (error) {
      //console.error('GTM - Error in approval_management_filterApply:', error)

    }
  }

  approval_management_afterClickSortOnly(actionName:string, linkName:string, ) {
    
    try {
        const eventData = {
        'event': 'approval_management_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'event_action': `${actionName} Click`, // Dynamically capture the CTA
        'link_name':`${linkName}`, // dynamically capture the sort option, eg: Oldest_Sort 
        'member':  this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };

      //console.log('approval_management_afterClickSort', eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_management_click', eventData);

    } catch (error) {

    }
  }

  approval_management_afterClickSort(actionName:string, linkName:string, ) {
    
    try {
        const eventData = {
        'event': 'approval_management_click',
        'screen_name': this.currentPage() || 'NA', // Dynamically capture the tab name
        'event_action': `${actionName} Click`, // Dynamically capture the CTA
        'link_name':`${linkName}_Sort`, // dynamically capture the sort option, eg: Oldest_Sort 
        'member':  this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Approval Management Workflow' // dynamically capture the POD name
      };

      //console.log('approval_management_afterClickSort', eventData)
      this.setGTM(this.cookiesService.analytics, 'approval_management_click', eventData);

    } catch (error) {

    }
  }

approvalSaveConfiguration(actionName:string,LinkName:string){
let eventData = {
  'event': 'approval_save_success',
  'screen_name': LinkName, // Dynamically capture the page name
  'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
  'event_action': `${actionName} Click`, // Dynamically capture the CTA
  'link_name': 'Success', // static
  'member': this.getUserRole(), // dynamically capture ex: employee
  'action': this._CommonService.actionName, // dynamically capture the feature name
  'subaction': 'Approval Management Workflow' // dynamically capture the POD name
}
//console.log('approval_management_afterClickSort', eventData)
this.setGTM(this.cookiesService.analytics, 'approval_save_success', eventData);
}
errorMessage(message:string,code:any,linkName:string){
  let eventData = {
    'event': 'view_error_message',
    'event_action':  'Error messages', // static
   'screen_name ':  linkName, // dynamically capture the current page name/title
     'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
   'link_name' : message,
   'error_message': message, // dynamic
   'error_code': code,
   'member': this.getUserRole(),   // dynamically capture ex: employee, Travel arranger
   'action': this._CommonService.actionName,// dynamically capture the feature name
    'subaction': 'Booking'// dynamically  capture the POD name
  }
  //console.log('approval_management_afterClickSort', eventData)
  this.setGTM(this.cookiesService.analytics, 'view_error_message', eventData);
}
}
